import { CmmStatus } from "../../../../enums/cmmStatus";
import { isNycbsRisaInProgress } from "./nycbsClientOutcome";

/**
 * Determines whether the Summary View button should be disabled for a row.
 * Disabled for RISA In Progress cases and when CMM status is not Success.
 *
 * @input responseStatus - Raw response_status from the order row
 * @input cmmStatus - Raw meta.cmm_st_rpa_status from the order row
 * @return boolean: True when the Summary View action should be disabled
 */
export const isNycbsSummaryViewDisabled = (
  responseStatus: string | null | undefined,
  cmmStatus: string | null | undefined,
): boolean => {
  if (isNycbsRisaInProgress(responseStatus)) {
    return true;
  }

  return cmmStatus !== CmmStatus.COMPLETED;
};
